<template>
  <swiper :options="swiperOption" class="swiper-box" v-if="listImg.length > 0">
    <swiper-slide class="swiper-item" v-for="(item, index) in listImg" :key="index">
        <img :src="item.imgUrl" @click='click(index)'>
    </swiper-slide>
    <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
  </swiper>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  props: ['listImg'],
  data () {
    return {
      swiperOption: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction: false,
        autoplay: 3000,
        loop: this.listImg.length > 1
      }
    }
  },
  mounted () {
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    click (index) {
      this.$emit('imgClick', index)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../css/var.styl';
// @import '../css/swiper.css';
.swiper-container
  width 100%
  height pt(400)
  .swiper-wrapper
    width 100%
    height 100%
  .swiper-slide 
    background-position center
    background-size cover
    width 100%
    height 100%
    img
      width 100%
      height 100%
      object-fit cover
  .swiper-pagination-bullet
    width 0.833rem
    height 0.833rem
    display inline-block
    background #31c27c
</style>



// WEBPACK FOOTER //
// banner.vue?e6c30570